var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNumber(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 2,
    fill: "#E5E5FF",
    stroke: "#C5C5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7207 6C10.4199 6 10.9824 6.19141 11.4082 6.57422C11.834 6.95312 12.0469 7.5625 12.0469 8.40234V12.6738H10.2598V8.84766C10.2598 8.37891 10.1738 8.02539 10.002 7.78711C9.83398 7.54883 9.56836 7.42969 9.20508 7.42969C8.6582 7.42969 8.28516 7.61523 8.08594 7.98633C7.88672 8.35742 7.78711 8.89258 7.78711 9.5918V12.6738H6V6.12305H7.36523L7.60547 6.96094H7.70508C7.8457 6.73438 8.01953 6.55078 8.22656 6.41016C8.4375 6.26953 8.66992 6.16602 8.92383 6.09961C9.18164 6.0332 9.44727 6 9.7207 6Z",
    fill: "#4141F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber);
export default __webpack_public_path__ + "static/media/number.22833ced778b18735c0de39a6e69d5c7.svg";
export { ForwardRef as ReactComponent };